import React, { Component } from 'react';
import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';
import ModalConfirmacao from './ModalConfirmacao';

const idUsuario = localStorage.getItem("CodUsuario");

class RemoverHistorico extends React.Component {

	constructor(props) {
		super(props);
		this.confirmacao = React.createRef();
		
		this.state = {
			icoOver: false,
			loading: false
		}
	}

	//Necessario melhorar esse codigo
  removerTudo = () => {
		return new Promise((resolve, reject) => {
			HttpUtil.eco_POST(Config.urls.API_URL_BASE + 'HistoricoArquivos/RemoverDadosHistorico/' + idUsuario, response => {
				console.log('response hist', response);

				if (response.status == 200) {
					resolve();
					this.setState({ loading: false })
				} else {
					reject('Ocorreu um erro ao excluir.');
					this.setState({ loading: false })
				}
				
			}, (err) => { 				
				if (err.status === 200) {
					window.location.reload();
					this.setState({ loading: false })
				} else {
					console.log('Ocorreu um erro ao executar a requisição', err);
					reject(err);
					this.setState({ loading: false })
				}
			})
		});
	}

  prepararParaRemover = () => {
		this.setState({ loading: true })
		this.removerTudo().then(() => {
			this.props.action();
		});
	}

  confirmarRemocao = () => {
		this.confirmacao.current.alterarVisibilidadeModal();
	}

	mouseOverHandler = () => {
		this.setState({ icoOver: !this.state.icoOver });
	}

	mouseLeaveHandler = () => {
		this.setState({ icoOver: false });
	}

  render() {

		return (
			<div className="d-inline">
				<i 
					className={
						this.state.loading
						? 
						'spinner-border spinner-border-sm text-danger' 
						: 
						'ecoico ecoico-excluir-cinza'
					}
					// onMouseEnter={this.mouseOverHandler} 
					// onMouseLeave={this.mouseLeaveHandler} 
					onClick={() => this.confirmarRemocao()}>
				</i>
				{/* <i className={this.state.icoOver ? 'ecoico ecoico-excluir-red' : 'ecoico ecoico-excluir-cinza'} onMouseEnter={this.mouseOverHandler} onMouseLeave={this.mouseLeaveHandler} onClick={() => this.confirmarRemocao()}></i> */}
				<ModalConfirmacao 
					ref={this.confirmacao} 
					mensagemAlerta="Deseja realmente excluir todo o histórico?" 
					action={this.prepararParaRemover.bind(this)} 
				/>
			</div>
		);

	}

}

export default RemoverHistorico;


// WEBPACK FOOTER //
// ./src/Componente/Modulo/RemoverHistorico.jsx